import { render, staticRenderFns } from "./NewsTip.vue?vue&type=template&id=4191e72b&scoped=true"
import script from "./NewsTip.vue?vue&type=script&lang=js"
export * from "./NewsTip.vue?vue&type=script&lang=js"
import style0 from "./NewsTip.vue?vue&type=style&index=0&id=4191e72b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4191e72b",
  null
  
)

export default component.exports